import { Grid, InputBase, Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import List from 'components/DataGrid/grid/List';
import Icon from 'icons/Icon';
import React, { CSSProperties, useState } from 'react';
import Entry from './Entry';

const useStyles = makeStyles((theme: Theme) => ({
  wrapper: {
    cursor: 'default',
    margin: 0,
    overflow: 'hidden',
    // padding: '4px 12px',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    userSelect: 'none',
    border: 0,
    outline: 'none',
    backgroundColor: theme.palette.background.paper,
  },
  title: {
    backgroundColor: theme.palette.background.default,
    lineHeight: '24px',
    padding: 8,
  },
  alert: {
    backgroundColor: theme.palette.info.light,
    marginTop: 8,
    padding: 4,
  },
  list: {
    listStyleType: 'none',
    margin: 0,
    padding: 0,
    border: 'none',
    outline: 'none',
  },
  searchIcon: {
    display: 'flex',
    margin: 8,
  },
}));

export type Props = {
  entries: string[];
  height: number;
  hideSearch?: boolean;
  onClick: (arg0: string) => void;
  onMouseEnter?: (arg0: string) => void;
  onMouseLeave?: (arg0: string) => void;
  title: string;
  // tool?: React.ReactNode;
  value: string;
  width: number;
  getLabel: (value: string) => string;
};

export default function Entries(props: Props) {
  const {
    entries,
    value,
    width,
    height,
    onMouseEnter,
    onClick,
    onMouseLeave,
    title,
    getLabel,
  } = props;

  const classes = useStyles();
  const [filter, setFilter] = useState('');

  const onFilterChange = (f: string) => {
    setFilter(f);
  };
  const filteredEntries = entries?.filter(
    (entry) => entry.toLowerCase().indexOf(filter.toLowerCase()) >= 0,
  );
  let { hideSearch } = props;
  if (!entries) return null;
  if (!(hideSearch || filter) && entries.length < 6) {
    hideSearch = true;
  }

  const h = height - 40 - (hideSearch ? 0 : 32);

  const CellComponent = ({
    rowIndex,
    style,
  }: {
    rowIndex: number;
    style?: CSSProperties;
  }) => {
    const c = filteredEntries[rowIndex];

    return (
      <Entry
        active={c === value}
        onClick={onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        style={style}
        value={c}
        getLabel={getLabel}
      />
    );
  };

  const searchInput = (
    <Grid container item xs alignItems="center">
      <Grid item xs="auto">
        <Icon className={classes.searchIcon} iconName="search" />
      </Grid>
      <Grid item xs>
        <InputBase
          fullWidth
          placeholder="Filter..."
          value={filter ?? ''}
          onChange={(e) => onFilterChange(e.target.value)}
        />
      </Grid>
    </Grid>
  );

  return (
    <div className={classes.wrapper}>
      <div className={classes.title}>{title}</div>
      {!hideSearch ? searchInput : null}
      <List
        className={classes.list}
        height={h}
        totalRows={filteredEntries.length}
        rowHeight={32}
        CellComponent={CellComponent}
        scrollToRow={value ? filteredEntries.indexOf(value) : undefined}
        width={width}
        custom
      />
    </div>
  );
}
